/**
 * get boolean value from the hidden div
 */
export const getHiddenDataBoolean = (id: string) => {
    const $el = document.getElementById(id);
    if(!$el) return false;

    return $el.innerText.trim().toLowerCase() === 'true';
};

/**
 * get string value from the hidden div
 */
export const getHiddenDataString = (id: string) => {
    const $el = document.getElementById(id);
    if(!$el || !$el.innerText) return '';

    return $el.innerText.trim();
};

/**
 * get numeric value from the hidden div
 */
export const getHiddenDataNumber = (id: string) => {
    const $el = document.getElementById(id);
    if(!$el || !$el.innerText) return 0;

    return Number($el.innerText.trim()) || 0;
};


/**
 * is user authenticated
 */
export const getIsAuthenticated = () => {
    return getHiddenDataBoolean('is-user-authenticated');
};

/**
 * get waves user email printed in the hidden DIV
 */
export const getWavesUserEmail = () => {
    const $el = document.getElementById('waves-user-email');
    if(!$el || !$el.textContent) return '';
    return $el.textContent.trim();
};

/**
 * is china
 */
export const getIsChina = () => {
    return getHiddenDataBoolean('is-china');
};

/**
 * is Kentico environment
 */
export const getEnvironment = () => {
    return getHiddenDataString('kentico-environment');
};